//declineApplicationAction
export const declineApplicationAction = (id) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(id);
      firestore
        .collection("applications")
        .doc(id)
        .delete()
        .then(() => {
          dispatch({
            type: "DELETE_APPLICATION",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "DELETE_APPLICATION_ERR",
            err
          });
        });
    };
  };
  